module.exports = __webpack_public_path__ + "static/media/search.c9d4c8b0.svg";